<template>
  <div
    class="content"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <van-cell-group class="applyCommunity-header">
      <div class="applyCommunity-tips">提示：通过搜索可快速查找您的小区</div>
      <div class="applyCommunity-search van-cell van-cell--center van-field">
        <div class="van-cell__value van-field__value van-cell__textarea">
          <div class="van-field__body">
            <div class="van-field__content">
              <input
                type="text"
                class="van-field__control"
                placeholder="搜索社区名称"
                v-model.trim="communityName"
                maxlength="20"
                @keyup.enter="searchCs"
              >
            </div>
            <div
              class="van-field__button"
              v-show="communityName"
              @click="communityName = ''"
            >取消</div>
          </div>
        </div>
      </div>
    </van-cell-group>
    <router-link
      to="/openCmt"
      tag="div"
      class="applyCommunity-passageway"
      style="color: #208FFF"
      v-show="communityList.length"
    >没有您想要的社区，点击申请开通</router-link>
    <van-list
      v-model="isUpLoading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onReachBottom"
      class="leaderboard-list"
    >
      <div
        class="applyCommunity-common"
        v-for="(item,index) in communityList"
        :key="index"
      >
        <div class="common-img">
          <img
            :src="imgPrex + item.headpic"
            alt
          />
        </div>
        <div class="common-title">
          <div
            class="common-shopName van-ellipsis"
            v-html="item.shopName"
          ></div>
          <div
            class="common-name"
            v-show="item.state != 0"
          >
            <span>已有社区店长</span>
          </div>
          <div class="common-address van-ellipsis"><span>{{item.distance | conversion}}km</span><span>{{item.address}}</span></div>
          <van-button
            class="common-btn"
            text="选这个"
            block
            v-show="item.state == 0"
            @click="goToRegister(item.originalShopName,item.communityId,item.state)"
          />
        </div>
      </div>
      <div
        class="notHave"
        v-if="!communityList.length && !isUpLoading && !error"
      >
        <img
          src="../../assets/img/sousuo_weikong.png"
          alt=""
        >
        <p>暂无搜索结果<br />请尝试其他搜索词</p>
        <van-button
          class="btn"
          text="增加社区"
          block
          to="/openCmt"
          v-if="!communityList.length"
        />
      </div>
    </van-list>
  </div>
</template>

<script>
import { csList, searchCsList } from "@/api/join";
export default {
  data() {
    return {
      communityList: [],
      communityName: "",
      keyword: "",
      isUpLoading: false,
      finished: false,
      pageIndex: 1,
      error: false,
    };
  },
  filters: {
    conversion(val) {
      return (val / 1000).toFixed(2);
    }
  },
  methods: {
    searchCs() {
      if (this.communityName == "") {
        return
      }
      this.keyword = this.communityName;
      // 清空列表数据
      this.pageIndex = 1;
      this.error = false;
      this.finished = false;
      this.communityList = [];
      // 重新加载数据
      // 将 isUpLoading 设置为 true，表示处于加载状态
      this.isUpLoading = true;
      this.getSearchCsList();
    },
    onReachBottom() {
      if (this.keyword == "") {
        return
      }
      this.getSearchCsList();
    },
    brightKeyword(val) {
      let keyword = this.communityName;
      if (val.indexOf(keyword) !== -1) {
        return val.replace(keyword, `<span style="color: #ff1310">${keyword}</span>`)
      } else {
        return val
      }
    },
    goToRegister(name, id, state) {
      if (state == 0) {
        let obj = {
          shopName: name,
          communityId: id,
        };
        this.$store.commit("user/SET_communityData", obj);
        this.$router.go(-1);
      }
    },
    getSearchCsList() {
      searchCsList({
        position: {
          // 无法获取经纬度信息时,两个值都传-1 ,后台按默认值定位处理
          longitude: this.$store.getters.longitude,
          latitude: this.$store.getters.latitude,
        },
        cityId: this.$store.getters.cityId,//城市ID	
        keyword: this.keyword,//社区关键字	
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.pageIndex, //请求页
          size: "20",//请求大小
        },
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          const list = res.content.list;
          list.map((item) => {
            item.originalShopName = item.shopName
            item.shopName = this.brightKeyword(item.shopName)
          })
          if (list.length < 10) {
            // 最后一页不足10条的情况
            this.finished = true;
          }
          // 处理数据
          if (this.pageIndex === 1) {
            this.communityList = list;
          } else {
            this.communityList = this.communityList.concat(list);
          }
          this.pageIndex++;
        } else {
          this.error = true;
        }
        this.isUpLoading = false;
      })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    }
  },
  mounted() {
    csList({
      position: {
        // 无法获取经纬度信息时,两个值都传-1 ,后台按默认值定位处理
        longitude: this.$store.getters.longitude,
        latitude: this.$store.getters.latitude,
      },
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        let list = res.content.list;
        list.map((item) => {
          item.originalShopName = item.shopName
        })
        this.communityList = list;
        this.finished = true;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 106px 0 10px;
  .applyCommunity-header {
    width: 100%;
    position: fixed;
    top: 44px;
    left: 0;
    z-index: 100;
  }
  .applyCommunity-search {
    padding: 12px;
    .van-field__content {
      flex: 1;
      padding: 9px 16px;
      background-color: #f5f5f5;
      border-radius: 21px;
    }
    .van-field__button {
      padding: 0 8px 0 20px;
      font-size: 15px;
      color: #444444;
      text-align: center;
    }
  }
  .applyCommunity-tips {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    font-size: 14px;
    background-color: #ffead8;
  }
  .applyCommunity-passageway {
    padding: 10px 12px 0;
    font-size: 12px;
  }
  .applyCommunity-common {
    display: flex;
    width: 335px;
    min-height: 52px;
    margin: 10px auto 0;
    padding: 10px 10px 12px;
    background-color: #fff;
    border-radius: 10px;
    position: relative;
    .common-img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 5px;
      }
    }
    .common-title {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .common-shopName {
        max-width: 200px;
        font-size: 14px;
        font-weight: bold;
      }
      .common-name {
        margin: 8px 0;
        color: #ff3838;
        font-size: 10px;
        span {
          padding: 4px 1px;
          text-align: center;
          background-color: #fff1f1;
          border-radius: 1px;
        }
      }
      .common-address {
        font-size: 12px;
        color: #333333;
        span {
          &:first-child {
            margin-right: 5px;
            color: #4495ff;
          }
        }
      }
    }
    .common-disabled {
      color: #999999 !important;
    }
    .common-btn {
      width: 60px;
      height: 26px;
      padding: 0;
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 14px;
      color: #ffffff;
      background-color: #ff9a34;
      border-radius: 16px;
    }
  }
  .notHave {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 77px;
    img {
      width: 47px;
      height: 50px;
    }
    p {
      margin-top: 14px;
      line-height: 18px;
      font-size: 12px;
      color: #999999;
      text-align: center;
    }
  }
  .btn {
    width: 355px;
    height: 50px;
    position: fixed;
    bottom: 14px;
    left: 10px;
    font-size: 16px;
    color: #ffffff;
    background-color: #ff9a34;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
    border-radius: 25px;
  }
}
.cover {
  .applyCommunity-header {
    top: 0;
  }
}
</style>